<template>
  <section class="mbs-wrap mbs012a" :style="dBHeight">
    <section class="mbs-header">
        <div class="inner">
            <div class="tit-box">
                <h3>{{$i18nUtil.trans("title.MyInfo.001","내 정보 관리")}}</h3>
            </div>
        </div>
    </section>
    <div class="pw-box photo-box">
      <div class="photo" id="photo">
          <img id="userPhoto" alt=""/>
      </div>
      <div class="info">{{$i18nUtil.trans("message.InternalUserInfo.001","* 서클 계정일 경우 개인정보 변경은 서클에서 가능하며, 서클에서 변경 시 동기화됩니다.")}}</div>
      <ul class="list-table" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' " v-if="userInfo !== null">
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.name","이름")}}</dt>
                  <dd>{{ !localeKo && userInfo.userNameEn != null ? userInfo.userNameEn : userInfo.userName }}</dd>
              </dl>
          </li>
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.userId","아이디")}}</dt>
                  <dd>{{userInfo.userId}}</dd>
              </dl>
          </li>
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.partnerName","소속회사")}}</dt>
                  <dd>{{ !localeKo && userInfo.companyNameEn != null ? userInfo.companyNameEn : userInfo.companyName }}</dd>
              </dl>
          </li>
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.jobPositionName","직위")}}</dt>
                  <dd>{{ !localeKo && userInfo.jobPositionNameEn != null ? userInfo.jobPositionNameEn : userInfo.jobPositionName }}</dd>
              </dl>
          </li>
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.jobFunctionName","직책")}}</dt>
                  <dd>{{ !localeKo && userInfo.jobFunctionNameEn != null ? userInfo.jobFunctionNameEn : userInfo.jobFunctionName }}</dd>
              </dl>
          </li>
          <li>
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.deptName","부서")}}</dt>
                  <dd>{{ !localeKo && userInfo.deptNameEn != null ? userInfo.deptNameEn : userInfo.deptName }}</dd>
              </dl>
          </li>
          <li v-if="seatReservation !== null">
              <dl>
                  <dt>{{$i18nUtil.trans("entity.user.seatReservation","근무지")}}</dt>
                  <dd>{{seatReservation}}</dd>
              </dl>
          </li>          
      </ul>
    </div>
  </section>
</template>

<script>
import "../../../../../assets/css/login.css";
import { mapState, mapActions } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
export default {
  data() {
        return {
            userInfo : null,
            seatReservation : null,
            error: false,
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },
            localeKo: this.$i18nUtil.getLanguage() === 'ko' ? true : false,
        }
    },
    mounted() {
      this.getMyInfo();
      this.getUserPhoto();
    },
    methods: {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
      getMyInfo(type) {
          let obj = this;
          let reqData = {
              url: "/api/auth/org/getMyInfo",
              method: "post",
          };
          obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function(res) {
              if(res.result !== null) {
                  if(res.result.errorCode !== undefined) {

                  } else {
                    obj.userInfo = res.result.orgDeptUserView;
                    obj.seatReservation = res.result.seatReservation;
                    if (!obj.seatReservation) {
                        obj.seatReservation = null;
                    }
                  }
              }
          })
          .catch(function(err) {
              console.log(err);
          });
      },
      getUserPhoto() {
        let img = document.getElementById("userPhoto");
        // img.style.width = "114px";
        // img.style.height = "114px";
        let imageURI = "/api/org/getUserPhoto";
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
          if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
            img.src = URL.createObjectURL(xhr.response);
            img.setAttribute("completed", true);
            img.classList.remove("hidden");
          }
        };
        xhr.open("GET", imageURI, true);
        var token = localStorage.getItem("Authorization");
        xhr.setRequestHeader("Authorization", token);
        xhr.responseType = "blob";
        xhr.send();
      },
    }
}
</script>

<style scoped>
    .pw-box .enCss > li > dl > dt {
        width: 120px;
    }
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/internal/InternalUserInfo.vue